<div class="main-container" [class.main-container--full]="layout === 'full'">
    <div class="editor-container editor-container_classic-editor" #editorContainerElement>
        <div class="editor-container__editor">
            <div #editorElement>
                <ckeditor [formControl]="formControlRef" [editor]="Editor" [config]="ckconfig" *ngIf="isLayoutReady" />
            </div>
        </div>
    </div>
</div>